import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import { saveAs } from "file-saver";
import { useNavigate } from 'react-router-dom'
import cssclass from "./cssclass";
//var dateFormat = require('dateformat');



const Renderform = () => {
const navigate = useNavigate();

const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");	
const resturl=sessionStorage.getItem("RESTURL");
const scansurl=sessionStorage.getItem("SCANSURL")??resturl;
const AD_USER=sessionStorage.getItem("AD_USER")??"";
const USERNAME=sessionStorage.getItem("USERNAME")??"";

const SUP_PVG=sessionStorage.getItem("SUP_PVG");
const FILUP_PIE_COLOR_PASSED = '#739bd0';//orange
const FILUP_PIE_COLOR_LEFT = '#b9e7ff';//lightgrey

//var boolFetchingSads=false;
//const navSubmitwptform = React.useRef();

//let sectionsHtmrows=[];// this needs to be available for the useEffect
const [progress, setProgress] = useState({
perct:null
});


const navSubmitform = React.useRef();
const navImportwpform = React.useRef();

const [dowait, setDowait] = useState({show: false});
const [dlwait, setDlwait] = useState({show:false});
const [latedlwait, setLatedlwait] = useState({show:false});
const [deferparams, setDeferparams] = useState({flag:"", msgtxt:"", btntxt:"", EML_MSG:"", DEFER_REASON:""});
const [email, setEmail] = useState({MESSAGE:''});
const [scans, setScans] = useState({dtviewed:''});
const [deferoptions, setDeferoptions] = useState([]);
const [deferreasons, setDeferreasons] = useState([]);
const [lscaseworkerapps, setLscaseworkerapps] = useState([]);

const [emlmsgs, setEmlmsgs] = useState([]);
const [cbvoucherpdf, setCbvoucherpdf] = useState({checked:false});

/*use the first useEffect to load options, sectionnames, arrFields*/
const [formoptions, setFormoptions] = useState([]);
const [combolaborcltype, setCombolaborcltype] = useState([]);
const [combolocation, setCombolocation] = useState([]);
const [comboreviewtype, setComboreviewtype] = useState([]);
const [emplids, setEmplids] = useState([]);


const [sectionnames, setSectionnames] = useState([]);
const [currsection, setCurrsection] = useState({index:null});
const [sectionsHtmrows, setSectionsHtmrows] = useState({htm:null});

const [arrFields, setarrFields] = useState([]);//array of fields from db records
const [currsectionfields, setCurrsectionfields] = useState([]);//which fields in arrFields apply to current section
/*
currsectionfields is only used in the call to updatewptapp
to say which fields in arrFields apply to current section
*/

const [formControls, setFormControls] = useState([]);//controls for each field
//wptapp comes from db wpt record and will look like arrFields as a single Object with a col for each field
const [wptapp, setWptapp] = useState({});
const [crit, setCrit] = useState({shownextbutton:0});


const [selectedFiles, setSelectedFiles] = useState([]);


const [axiofl, setAxiofl] = useState({
selectedFile: null
});

//const [section, setSection] = useState({letter:'A',name:'',index:0});

const [tblsections, setTblsections] = useState([]);







const location = useLocation();


useEffect(() => {
/*
*/

document.title =   "APS Work Permit Form";	

//if (sessionStorage.getItem("VERIFY_DATE")==null && (sessionStorage.getItem("NUM_ROLES")==0||sessionStorage.getItem("NUM_ROLES")==null))
	//navigate('/login');
if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if
	
if (formoptions.length<1){
	loadwptform();
	}//end if

 },[]);


useEffect(() => {
	/*
	after the fields are set, then initialize get the wptapp
	, then set currsection.index, which triggers the writeformcontrols()
	*/
	if (arrFields.length>0){
		
		if (location.state.wptapp)
			setWptapp(location.state.wptapp);

		if (location.state.WPT_APP_ID)
			setWptapp((prev)=>{
				return {...prev, WPT_APP_ID:location.state.WPT_APP_ID}
			});

		}//end if
		
	
 },[JSON.stringify(arrFields)]);



useEffect(() => {
	//when currsection.index changes call writeformcontrols()
	
	
	if (currsection.index!=null){
		if (currsection.index==10){
			setFormControls([]);
			if (document.getElementById('form1'))
				document.getElementById('form1').style.display='block';
			/*
			2026-05-13
			call to getwptvouchers(); was moved to useEffect wptapp.WPT_APP_ID to facilitate reload after getnextwptapp();
			that caused a problem so restore it here and try to call it at getnextwptapp();
			setCurrsection({index:null}); was added before call 
			*/
			getwptvouchers();
			}
		else{
			if (document.getElementById('form1'))
				document.getElementById('form1').style.display='none';
			writeformcontrols();
			}
		}//end if
	
 },[currsection.index]);
 
 
 
 useEffect(() => {
		
	let msgtxt="", btntxt="";
	
	console.log('deferparams.flag: '+deferparams.flag);

	if (deferparams.flag!=""){
		msgtxt = deferparams.flag=="d"?"deferred":"cancelled";
		btntxt = deferparams.flag=="d"?"defer":"cancel";
		setDeferparams((prev)=>{return {...prev, msgtxt:msgtxt, btntxt:btntxt, EML_MSG:"", DEFER_REASON:""}});
		toggleModalsm();
		}//end if
		

 },[deferparams.flag]);

 useEffect(() => {
		
	//console.log("deferparams: "+JSON.stringify(deferparams));
	
 },[deferparams]);
 


useEffect(() => {

if (!progress.perct)
	return;

if (progress.perct>0){
	console.log("progress.perct: "+progress.perct);
	updateProgressElement(progress.perct);
	}
	

 },[progress.perct]);

 
useEffect(() => {

if (formControls.length>0)
	setDowait({show:false});	
		
 },[JSON.stringify(formControls)]);


useEffect(() => {

if (arrFields.length>0)
	setDowait({show:false});	
		
 },[JSON.stringify(arrFields)]);
 
 
 
useEffect(() => {
	/*
	after get the wptapp
	, then set currsection.index, which triggers the writeformcontrols()
	*/
	if (wptapp.WPT_APP_ID!=undefined && wptapp.REF_NUM==undefined){
		//this the initial set WPT_APP_ID from location.state
		setCurrsection({index:null});
		getwptapp();
		}//end if
	else if (wptapp.REF_NUM!=undefined && wptapp.doSectionChange==true){
		//console.log('wptapp doSectionChange: '+wptapp.doSectionChange);
		//console.log('wptapp useEffect: '+wptapp.VSR_SUR_NAM);
		let sectionIndex=0;

/*
		let SCTN=(location.state.SCTN==undefined)?"":location.state.SCTN;
		const SUBMITTED_TO_CSC=(location.state.SUBMITTED_TO_CSC==undefined)?"":location.state.SUBMITTED_TO_CSC;
		console.log("SUBMITTED_TO_CSC: "+SUBMITTED_TO_CSC);
		getwptappfile
*/
//console.log('wptapp SUBMITTED_TO_CSC: '+wptapp.SUBMITTED_TO_CSC);
		let SCTN=(location.state.SCTN==undefined)?"":location.state.SCTN;
		if (SCTN=="")
			SCTN=( (wptapp.SUBMITTED_TO_CSC==null || wptapp.SUBMITTED_TO_CSC=="") && (wptapp.FORM_DROP_OFF_DATE==null || wptapp.FORM_DROP_OFF_DATE=="") )?"A":"K";
	
		console.log('SCTN: '+SCTN);
		if (SCTN!=''){
			for (var i=0; i<sectionnames.length; i++)
				if (sectionnames[i].letter==SCTN){
					sectionIndex=i;
					console.log('default to sectionIndex: '+sectionIndex);
					}//end if
			}//end if
		handleSectionChange(sectionIndex);//setCurrsection({index:0}
		}
	
 },[wptapp]);


useEffect(() => {
	
	if (sectionnames.length>0){
		//console.log('sectionsHtmrows.length: '+sectionsHtmrows.htm.length);
		setTblsections(sectionsHtmrows.htm);
		}//end if
		
	
 },[JSON.stringify(sectionnames)]);

useEffect(() => {
	
	const WPT_APP_ID=wptapp.WPT_APP_ID??0;
//	console.log("WPT_APP_ID: "+WPT_APP_ID);
	if (WPT_APP_ID>0){
/*
		if (lscaseworkerapps.length==0)
			getlscaseworkerapps();//getlscaseworkerapps() will call getwptvouchers(); when done
		else
*/


/*
console.log("currsection.index: "+currsection.index);
		if (currsection.index==10)
			getwptvouchers();

*/


		}//end if
	
 },[wptapp.WPT_APP_ID]);


function aftergetwptapp(res){

//let datas={};
let datas=wptapp;
//datas['REF_NUM']=res[0].REF_NUM;

for(var attributename in res[0]){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
	}//end for	
	
	//setWptapp(datas);


setWptapp((prev)=>{
	return {...prev, doSectionChange:true, datas}
});

setDowait({show:false});


if (AD_USER!="" && datas.SUBMITTED_TO_CSC!='')
	getdocsdlcount();
}//end func



async function getlscaseworkerapps(){

console.log("enter getwptapp()");

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WPT_APP_ID:wptapp.WPT_APP_ID, USERNAME:sessionStorage.getItem("USERNAME")} )
  };		

	setDowait({show:true});

  await fetch(resturl+'rarwpform/getlscaseworkerapps',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetlscaseworkerapps(res) )
      .catch(err => console.log(err));

}//end func

function aftergetlscaseworkerapps(res){
	
	let temp=[];
	
	res.map((col, index) => {
	const key="cswapps_"+index;
	
	temp.push(<option key={key} value={col['WPT_APP_ID']}  >{col['APP_NAMES']}</option>);

	});//end map
	
	setLscaseworkerapps(temp);
	
}//end func

async function getwptapp(){

console.log("enter getwptapp()");

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WPT_APP_ID:wptapp.WPT_APP_ID, USERNAME:sessionStorage.getItem("USERNAME")} )
  };		

	setDowait({show:true});

  await fetch(resturl+'rarwpform/getwptapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptapp(res) )
      .catch(err => console.log(err));

}//end func

async function getdocsdlcount(){

const params={
	TBL: "WPT"
	, WPT_APP_ID:wptapp.WPT_APP_ID
	, AD_USER:sessionStorage.getItem("AD_USER")??""
	, FILENAME:"scans.pdf"
	, FLAG_DL:0
	} 

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params)
  };		

 await fetch(resturl+'rarwpform/getdocsdlcount',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetdocsdlcount(res) )
      .catch(err => console.log(err));

}//end func

function aftergetdocsdlcount(res) {
	if (res.length!=undefined)
		setScans({dtviewed:res[0].STAMP});
}//end func



function clickCbvoucherpdf(e){
	setCbvoucherpdf({checked:e.target.checked});
	
	if (e.target.checked==true){
		window.alert("If there is a receipt voucher that fails to load,\r\nyou can next click it to try regenerate it,\r\nIt takes a minute or two, so please wait after clicking it");
		}//end if
	
}//end func



async function logvchrpdffile(e, doc){
	

const params={
	USERNAME:sessionStorage.getItem("USERNAME")??""
	, DOC_NO:doc.DOC_NO??0
	}//

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params  )
  };		

  await fetch(resturl+'rarwpform/logvchrpdffile',requestOptions)
      .then(res => res.json())
      .then(res => 	afterlogvchrpdffile(res, e, doc) )
      .catch(err => console.log(err));
	
	
}//end func

function afterlogvchrpdffile(res, e, doc){
	const UPDATE_COUNT=res.length?(res[0].UPDATE_COUNT??0):0;
	if (UPDATE_COUNT>0)
		makevchrpdffile(e, doc);
	else
		window.alert("failed! please try again or contact admin");
}//end func


async function makevchrpdffile(e, doc){
	

	cssclass(e.target.id, "hidden", 1);
	
	//let PAID_AMT=doc.PAID_AMT.toString().match(/[0-9].*/g);
	//PAID_AMT=PAID_AMT.length?PAID_AMT[0]:PAID_AMT;
	
	//let PAID_DATE=doc.PAID_DATE??"";
	
	const params={
		DOC_NO: doc.DOC_NO
		, PAID_AMT: 0
		, PAID_DATE: ""
			};
	
	console.log("makevchrpdffile: "+JSON.stringify(params));
	const filename=doc.DOC_NO+".pdf";
	//const filename="RCP.pdf";

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,responseType: "blob"
	  ,body: JSON.stringify( params )
  };		


	await fetch(customspremurl+'rarvchrpdffile/makevchrpdffile',requestOptions)
	  .then(data => aftermakevchrpdffile(data, e, filename) )
      .catch(err => console.log(err));	

}//end func


async function aftermakevchrpdffile(res, e, filename){
	cssclass(e.target.id, "hidden", 0);
	
	const blob = await res.blob();
	saveAs(blob, filename);
	
}//end func





async function downloadDoc(e, docNo){
	e.preventDefault();
	
	if (document.getElementById("cbvoucherpdf").checked==true){
		const doc={DOC_NO: docNo};
		logvchrpdffile(e, doc);
		//makevchrpdffile
		return;
		}//end if
	
	cssclass(e.target.id, "hidden", 1);
	
	const filename=docNo+".pdf";
	//const filename="RCP.pdf";
	
	
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,responseType: "blob"
	  ,body: JSON.stringify( {filename: filename} )
  };		
//setTblvchrs([]);
 await fetch(customspremurl+'rarwptapp/getvchrpdffile',requestOptions)
     
      .then(data => 	afterdownloadDoc(data, e, filename) )
      .catch(err => console.log(err));	
	
	
}//end func

async function afterdownloadDoc(res, e, filename){
	cssclass(e.target.id, "hidden", 0);
	
	const blob = await res.blob();
	saveAs(blob, filename);
	

}//end func


async function getvchrstate(e, docNo){
	//getvchrstate
	e.preventDefault();
e.target.style.visibility='hidden';

const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( {DOC_NO:docNo})
};		

await fetch(customspremurl+'rarwptapp/getvchrstate',requestOptions)
  .then(res => res.json())
  .then(res => 	aftergetvchrstate(res, e.target, docNo) )
  .catch(err => console.log(err));	
	
}//end func

function aftergetvchrstate(res, elem, docNo){
	elem.style.visibility='visible';
var DOC_STATE_DESC=null;
if (res.length)
	if (res.length==1)
		DOC_STATE_DESC=res[0].DOC_STATE_DESC;
	
if (DOC_STATE_DESC=='DISCARDED')
	cancelwpdoc(docNo);
else
	window.alert('First change document status from '+DOC_STATE_DESC+' to DISCARDED in SIGTAS');
	
}//end func

async function cancelwpdoc(docNo){


const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( {DOC_NO:docNo, USERNAME:sessionStorage.getItem("USERNAME")})
};		

await fetch(resturl+'rarwpform/cancelwpdoc',requestOptions)
  .then(res => res.json())
  .then(res => 	aftercancelwpdoc(res) )
  .catch(err => console.log(err));	
	
}//end func

function aftercancelwpdoc(res){
	let cancel_count=0;
	if (res.length)
		if (res.length==1)
			cancel_count=res[0].CANCEL_COUNT;
		
	if (cancel_count==0)
		showsnackbar("that failed.  please try again or contact admin");
	else{
		showsnackbar("cancellation complete on APS Portal only.<br/>SIGTAS is not automatically updated");
		getwptvouchers();
		}
		
}//end func


function tblwptprogress(){
//<><div align='center'><a href="#" onClick={(e)=>{e.preventDefault(); navigate("/startlcrapp", {state:{WPT_APP_ID:wptapp.WPT_APP_ID}}); }} className="nodecor" ><img src="img/folderyelsmall.png" border="0" /> open Labour Clearance input form</a></div></>;	
//style={{borderCollapse:"collapse"}}
/*
C8213
Anattalee Campbell nee Pusey
*/
return <>
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"20px"}} >Application Progress</p>
	<table align='center' border="1" className="customers" width="98%"  >
	<thead>
	<tr>
		<th>Drop<br/>Off</th>
		<th>10%<br/>Receipt</th>
		<th>Labour<br/>Clearance</th>
		<th>Balance<br/>Receipt</th>
		<th>Work<br/>Permit</th>
		<th>Card<br/>Print</th>
	</tr>
	</thead>
	<tbody>
	<tr>
		<td>&nbsp;</td>
		<td>&nbsp;</td>
		<td><a href="#" onClick={(e)=>{e.preventDefault(); navigate("/lbr_clr_app", {state:{BACK_PAGE:"wptform", WPT_APP_ID:wptapp.WPT_APP_ID, IPM_LBR_CLR_APP_ID:wptapp.IPM_LBR_CLR_APP_ID}}); }} className="nodecor" ><img src="img/runman.png" border="0" />&nbsp;&nbsp;Id #: {wptapp.WPT_APP_ID}</a></td>
		<td>&nbsp;</td>
		<td>&nbsp;</td>
		<td>&nbsp;</td>
	</tr>
	</tbody>
	</table>
	</>;
}//end func

async function cancelduplicatercpvchr(e){
e.preventDefault();

const confirmed=window.confirm("cancel duplicated receipt vouchers?");
if (!confirmed)
	return;

const params = {
	 USERNAME: sessionStorage.getItem("USERNAME")
	, WPT_APP_ID:wptapp.WPT_APP_ID
	}

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

 await fetch(resturl+'rarwpform/cancelduplicatercpvchr',requestOptions)
      .then(res => res.json())
      .then(res => 	aftercancelduplicatercpvchr(res) )
      .catch(err => console.log(err));

}//end func

function aftercancelduplicatercpvchr(res){
const UPDATE_COUNT=res.length?(res[0].UPDATE_COUNT??0):0;
if (UPDATE_COUNT==0)
	window.alert("seems no duplicates were found to cancel.\r\nbe certain the desired vouchers are paid");
else{
	getwptvouchers();
	showsnackbar(UPDATE_COUNT+" duplicates were cancelled");
	}
	
}//end func


async function getwptvouchers(){


const params = {
	VCHR_TYPE:"LC"
	, USERNAME: sessionStorage.getItem("USERNAME")
	, WPT_APP_ID:wptapp.WPT_APP_ID
	}

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

 await fetch(resturl+'rarwpform/getwptvouchers',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptvouchers(res) )
      .catch(err => console.log(err));

}//end func

function aftergetwptvouchers(res){

//console.log("aftergetwptvouchers: "+JSON.stringify(res));
	
let vchrs_htmrows=[], defers_htmrows=[];

let htmWptprogress=(sessionStorage.getItem("AD_USER")=="")?<></>:tblwptprogress();

const vchrs=res[0].vchrs;
const defers=res[0].defers;


	vchrs.map((col, index) => {
		
		const key="tblvchrs_"+index;
		const docNo=col['DOC_NO'];
		const downloadLink=<a href="#" className="nodecor" id={"link_"+index} onClick={(e)=>{downloadDoc(e, docNo);}} ><img src='img/pdf.gif' border='0' />&nbsp;{docNo}</a>;
		
		const htmrow=<tr key={key} >
		
					<td align="left" >{col['STR_CREATE_DATE']}</td>
					<td align="left" >{downloadLink}</td>
					<td className="tlnrgt" >{col['AMOUNT']}</td>
					<td align="left" title={col['VCHR_COMMENT']} >
					<a href="#" onClick={(e)=>{getvchrstate(e, docNo);}} className="nodecor" ><img src="img/noicon.png" border="0" />&nbsp;{col['ACCT_DESCP_1']}</a>
					</td>
					<td align="left" >{col['CHR_DATE_PAID']}</td>
					</tr>;
		vchrs_htmrows.push(htmrow);
		
		});//end map
		
	defers.map((col, index) => {
		
		const key="tbldefers_"+index;
		const docNo=col['DOC_NO'];
		const downloadLink=<a href="#" className="nodecor" id={"link_"+index} onClick={(e)=>{downloadDoc(e, docNo);}} ><img src='img/pdf.gif' border='0' />&nbsp;{docNo}</a>;
		
		const htmrow=<tr key={key} >
					<td align="center" >{col['STAMP_DATE']}<br/>{col['STAMP_TIME']}<br/>{col['USERNAME']??""}</td>
					<td align="left" >{col['DEFER_REASON']}</td>
					</tr>;
		defers_htmrows.push(htmrow);
		
		});//end map		

let IRD_LOGIN_ID=sessionStorage.getItem("IRD_LOGIN_ID");


const tblvchrsanddefers=<>
				<p align="center" className="Acme" style={{marginBottom:"0px", marginTop:"9px", color:"brown",fontSize:"20px"}} >Vouchers</p>
				{
					vchrs_htmrows.length==0 && <p>this table is currently empty</p>
				}
				{
					vchrs_htmrows.length>0 && <>
					<table align="center" className="customers" >
					<thead>
					<tr>
					<th align="left" >Date</th>
					<th align="left" >Doc. #</th>
					<th align="left" >Amount</th>
					<th align="left" >Description</th>
					<th align="left" >Date Paid</th>
					</tr>
					</thead>
					<tbody>
					{vchrs_htmrows}
					</tbody>
					</table>
					<table align="center" width="98%" >
					<tbody>
					<tr>
						<td align="center">
						<input type="checkbox" id="cbvoucherpdf" onClick={(e)=>{clickCbvoucherpdf(e);}} />
						<label htmlFor="cbvoucherpdf"  className="hand" >Regenerate pdf file</label>
						</td>
						<td align="center">
						<a href="#" className="nodecor" onClick={(e)=>{ cancelduplicatercpvchr(e); }} ><img src="img/cancel.png" height="20" /> cancel duplicates</a>
						</td>
					</tr>
					</tbody>
					</table>
					</>
				}
				<div align="center" style={{marginTop:"5px", marginBottom:"8px"}} ><a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/wptapprcpvchr", {state:{WPT_APP_ID:wptapp.WPT_APP_ID, MPE_NAME: wptapp.MPE_FIRST_NAME+" "+wptapp.MPE_LAST_NAME}});}} ><img src="img/add-button.png" height="20" /> add receipt numbers</a></div>
				
				<p align="center" className="Acme" style={{marginBottom:"0px", marginTop:"9px", color:"brown",fontSize:"20px"}} >Deferals</p>
				{
					defers_htmrows.length==0 && <p>this table is currently empty</p>
				}
				{
				defers_htmrows.length>0 && <>
					<table align="center" className="customers" >
					<thead>
					<tr>
					<th align="left" >Date</th>
					<th align="left" >Reason</th>
					</tr>
					</thead>
					<tbody>
					{defers_htmrows}
					</tbody>
					</table>
					</>
				}



				
				{htmWptprogress}
				</>;
setFormControls(tblvchrsanddefers);

}//end func




async function updateReviewtype(e){
	
	e.preventDefault();
	
	const params={
		USERNAME: sessionStorage.getItem("USERNAME")
		, WPT_APP_ID: wptapp.WPT_APP_ID
		, APP_TYPE_ID: wptapp.APP_TYPE_ID
		, REVIEW_TYPE: wptapp.REVIEW_TYPE
		, ONLY_UPDATE_REVIEW_TYPE: 0
	}
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

await fetch(resturl+'rarwpform/updatereviewtype',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdateReviewtype(res) )
      .catch(err => console.log(err));


}//end func


function afterupdateReviewtype(res){
	
if (wptapp.CONCESSION==1 && wptapp.STATUS=='NEW'){
	approveconssn();
	}	
else	
	navigate("/wpvouchers",{state:{WPT_APP_ID:wptapp.WPT_APP_ID, BACK_PAGE:"wptform"}});
}//end func


async function loadwptform(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {govt:0} )
  };		

setDowait({show:true});

 await fetch(resturl+'rarwpform/loadwptform',requestOptions)
      .then(res => res.json())
      .then(res => 	afterloadwptform(res) )
      .catch(err => console.log(err));

}//end func


function afterloadwptform(res){
/*
will try initialize all the below using the formload data
const [formoptions, setformoptions] = useState([]);
const [sectionnames, setSectionnames] = useState([{letter:'A',name:'INFORMATION ABOUT THE PERSON TO BE EMPLOYED'}]);
const [currsection, setCurrsection] = useState({index:0});
const [arrFields, setarrFields] = useState([]);//array of fields from db records
const [formControls, setFormControls] = useState([]);//controls for each field
const [wptapp, setWptapp] = useState();//transform arrFields into a single Object with a col for each field
*/
initializeformoptions(res[0].options);
initializesectionnames(res[0].sections);
setarrFields(res[0].fields);

}//end func


function initializesectionnames(res){
let temp=sectionnames;
let htmrows=[];
let rowcount=1;
res.map((col, index) => {
	const letter=col['SCTN_LETTER'];
	const shortname=col['SHORT_NAME'];
	const name=col['SCTN_NAME'];
	
	const trkey='tr_'+letter;
	const tdkey='td_'+letter;
	const rdkey='rd_'+letter;
	const pIndex=rowcount-1;//calling requires constant value for index
	const rdsection=<><input type='radio' name='rdsection' key={rdkey} id={rdkey} onClick={(e)=>{handleSectionChange(pIndex);}} /><label htmlFor={rdkey} className='hand'  >{shortname}</label></>;
	htmrows.push(<tr key={trkey} ><td  style={{"paddingTop":"12px"}} key={tdkey}  >{rdsection}</td></tr>);
	//if (rowcount>1)
		temp.push({letter:letter,name:name});
	rowcount++;
	});//end map

setSectionnames(temp);

setSectionsHtmrows((prev)=>{
	return {...prev, htm:htmrows}
});

//console.log('sectionsHtmrows.length: '+sectionsHtmrows.length);

}//end func

function initializeformoptions(res){
let temp=[];
let templaborcltype=[];
let templocation=[];
let tempreviewtype=[], tempdeferoptions=[], emlmsgs=[], reasons=[];

res.map((col, index) => {
	const combo=col['COMBO'];
	const key=combo+"_"+index;
	const key2=combo+"_"+index+"_2";
	const opt=col['OPT'];
	//the value of combo is integer in 2 cases: MPE_OCCUPATIONID and AGENCY_ID
	const val=(combo=='agencyid' || combo=='occupationid')? col['VAL']:opt;
	//console.log('afterfetchctrycodes nam: '+nam);
	
	temp.push({name:combo, options:<option key={key} value={val}  >{opt}</option>});
	if (combo=='laborcltype')
		templaborcltype.push(<option key={key} value={col['VAL']}  >{opt}</option>);
	else if (combo=='location')
		templocation.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='reviewtype')
		tempreviewtype.push(<option key={key} value={col['VAL']}  >{opt}</option>);
	else if (combo=='deferreason'){
		reasons.push(col['VAL']);
		emlmsgs.push(opt);
		tempdeferoptions.push(<option key={key} value={col['VAL']}  >{col['VAL']}</option>);
		}//end if

	});//end map
setFormoptions(temp);
setCombolaborcltype(templaborcltype);
setCombolocation(templocation);
setComboreviewtype(tempreviewtype);
setDeferoptions(tempdeferoptions);
setDeferreasons(reasons);
setEmlmsgs(emlmsgs);
}//end func

function writeformcontrols(){
	
//console.log('usearrFields sectionLetter: '+sectionLetter);

let tempFormControls=[];
let tempcurrsectionfields=[];

if (arrFields==null || arrFields==undefined || arrFields=='null' || arrFields=='undefined' || arrFields.error){
	console.log('will exit writeformcontrols for arrFields==null || arrFields==undefined .');
	return;
	}//end if
	
if (arrFields.length<1){
	console.log('will exit writeformcontrols for arrFields.length<1 ?');
	return;
	}//end if	
//else
	//console.log('writeformcontrols arrFields.length: '+arrFields.length);

let fileCount=0;
setDowait({show:true});	

arrFields.map((col, index) => {
	const sctn=col['SCTN'];
	const fld=col['FLD'];
	const datafield=col['DATAFIELD'];
	let typ=col['TYP'];
	const rqd=col['RQD'];
	let comboplus='';
	if (typ=='combo+'){
		typ='combo';
		comboplus=<><a href='#' onClick={(e)=>{clickComboplus(e, fld);}} ><img src='img/add.png' height="18" border='0' /></a></>;
		}//end if
	
	
	if (sctn==sectionnames[currsection.index].letter){
		tempcurrsectionfields.push(index);
		const currfileCount=fileCount;
	//.replace('\r', '<br/>').replace('\n', '<br/>')
		const key="_key_"+index;
		
		const opt=col['OPT'];
		const elemId=col['FLD'];
		//const redstar = (datafield==1 && rqd==1)?<span style={{color:'red'}}>*&nbsp;</span>:<></>;
		const lbl=col['SLBL'];
		//(datafield==1 && rqd==1)?:<><span style={{color:'red'}}>*&nbsp;</span>{col['LBL']}</>:<>col['LBL']</>;
		//if (typ=='combo') {console.log('opt: '+opt);}
		
		let inputsize=20;
		if (opt!=null)
			inputsize=1*opt;
		
		let opts=[];
		

	//const checkboxes=getcheckboxes(opt);s
		if (typ.startsWith('combo'))
			for (var i=0; i<formoptions.length; i++)
				if (formoptions[i].name==opt)
					opts.push(formoptions[i].options);

		//console.log('afterfetchctrycodess nam: '+nam);
		if (typ=='textarea')
			tempFormControls.push(<div align='left' className="formcontrols" style={{"paddingTop":"0px"}} key={"div"+key} ><label key={"lbl"+key} htmlFor={elemId} dangerouslySetInnerHTML={{__html: lbl}} ></label><br/><textarea key={"textarea"+key} name={fld} id={elemId} onChange={(e)=>{handleChange(e, typ, rqd);}} autoComplete='off' onFocus={(e)=>{e.target.select();}} cols="50" rows="4" defaultValue={wptapp[fld]} ></textarea></div>);
		else if (typ=='combo')
			tempFormControls.push(<div align='left' className="formcontrols" key={"div"+key} ><label key={"lbl"+key} htmlFor={elemId} dangerouslySetInnerHTML={{__html: lbl}} ></label><br/><select key={"combo"+key} name={fld}  id={elemId} title={wptapp[fld]}   defaultValue={wptapp[fld]}  onChange={(e)=>{handleChange(e, typ, rqd);}} style={{maxWidth:"400px"}} ><option value='' key={'opt'+key} ></option>{opts}</select>&nbsp;&nbsp;{comboplus}</div>);
		else if (typ=='sectionhead')
			tempFormControls.push(<div align='left' className="formcontrols" key={"div"+key} ><p className="wpsectionhead" >{lbl}</p></div>);
		else if (typ=='msg')
			tempFormControls.push(<div align='center' className="formcontrols" key={"div"+key} ><p className="wpmsg" dangerouslySetInnerHTML={{__html: lbl}} ></p></div>);
		else if (typ=='date')
			tempFormControls.push(<div align='left' className="formcontrols" key={"div"+key} ><label key={"lbl"+key} htmlFor={elemId} dangerouslySetInnerHTML={{__html: lbl}} ></label><br/><input key={"input"+key} name={fld} id={elemId} defaultValue={wptapp[fld]}  onChange={(e)=>{handleChange(e, typ, rqd);}} type='date'  onFocus={(e)=>{e.target.select();}} /></div>);
		else if (typ=='file'){
			let filename='';
			if (fileCount==0)
				filename="scans.pdf";

			

			tempFormControls.push(<div align='left' className="formcontrols" key={"div"+key} style={{marginBottom:"8px"}} ><label key={"lbl"+key} htmlFor={elemId} dangerouslySetInnerHTML={{__html: lbl}} ></label><br/><input key={"input"+key} name={fld} id={elemId}   onChange={(e)=>{selectedFilesChange(e, currfileCount, filename);}} type='file' onFocus={(e)=>{e.target.select();}} /></div>);
			{/* <br/><a href={refurl+filename} target="_none" className="nodecor" >{wptapp[fld]}</a> */}
			//if (wptapp.LATE_SCAN_ALLOW>0)
				//tempFormControls.push(<p align='center' className="formcontrols" ><a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/wptappscan", {state:{wptapp:wptapp}});}} ><img src="img/addbutton.png" border="0" /> manage scanned documents</a></p>);
				
			fileCount++;
			}
		else if (typ=='checkbox')
			tempFormControls.push(<div align='left' className="formcontrols" key={"div"+key} ><label key={"lbl"+key} htmlFor={elemId} >{lbl}</label><br/>{opts}</div>);
		else{
			//default (typ=='text')
			tempFormControls.push(<div align='left' className="formcontrols" key={"div"+key} ><label key={"lbl"+key} htmlFor={elemId} dangerouslySetInnerHTML={{__html: lbl}} ></label><br/><input key={"text_input"+key} name={fld} id={elemId} defaultValue={wptapp[fld]} size={inputsize}  onChange={(e)=>{handleChange(e, typ, rqd);}} type='text' autoComplete='off' onFocus={(e)=>{e.target.select();}} /></div>);
			}
		
	}//end if
	
	});//end map



//console.log('formoptions.length: '+formoptions.length);

setFormControls(tempFormControls);

setCurrsectionfields(tempcurrsectionfields);
/*
currsectionfields is only used in the call to updatewptapp
to say which fields in arrFields apply to current section
*/
	

}//end func



function handleSectionChange(pIndex){
	
//console.log('sectionnames: '+JSON.stringify(sectionnames));
	
//verify the array of sections is loaded
//console.log('handleSectionChange sectionnames.length: '+sectionnames.length);
//console.log('handleSectionChange pIndex: '+pIndex);
//if (!pIndex<sectionnames.length)
//	pIndex=sectionnames.length-1;

const letter=sectionnames[pIndex].letter;
//const name=sectionnames[pIndex].name;
setCurrsection({index:pIndex});

//console.log('handleSectionChange letter: '+letter);

if (document.getElementById('rd_'+letter))
	document.getElementById('rd_'+letter).checked=true;

}//end funcs

function clickComboplus(e, fld){
e.preventDefault();	
const elem=document.getElementById(fld);
	const userOpt=prompt('Please enter your intended option:');
	if (userOpt){
		console.log('elem.selectedIndex: '+elem.selectedIndex);
		var opt = document.createElement('option');
		opt.value = userOpt;
		opt.innerHTML = userOpt;
		const len=elem.length;
		console.log('len: '+len);
		elem.appendChild(opt);
		elem.selectedIndex=len;
		setWptapp((prev) => {
		return {...prev, doSectionChange:false, [fld]:userOpt}
		});
		showbtnsave();
		}//end if
	else
		elem.selectedIndex=0;
	
}//end if

function showbtnsave(){
if (document.getElementById('btnsavechanges'))
	document.getElementById('btnsavechanges').style.visibility='visible';
if (document.getElementById('btnsubmitapp'))
	document.getElementById('btnsubmitapp').style.visibility='hidden';	
}//end func

function dateBlurOld(e, rqd){
const {name, value}=e.target;
const yr=(""+value).substring(0,4);
//console.log('yr : '+yr);
const currdate=new Date().toISOString().slice(0, 10);
const curryr=currdate.substring(0,4);
//console.log('curryr : '+curryr);
const yearDiff=Math.abs(yr-curryr);
console.log('yearDiff : '+yearDiff);
if (yearDiff>100){
	//let correction=""+value;
	//correction=correction.replace(yr+"-",curryr+"-");
	document.getElementById(name).value="";
	setWptapp((prev) => {
	return {...prev, doSectionChange:false, [name]:""}
	});
	showsnackbar("The year "+yr+" that you selected was not accepted");
	}//end if
}//end func



function emplIdFocus(e){
	console.log("emplIdFocus");
if (document.getElementById("btnsavempr"))
	document.getElementById("btnsavempr").style.visibility="visible";
	
}//end func


function isNumeric(str) {
  if (typeof str != "string") return false // we only process strings!  
  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
         !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

function moneyCheck(item){

const res=item.replace(/[^\d.-]+/g, '');

if (!isNumeric(res)){
	console.log(item+ ' failed isNumeric check');
	return "";
	}

return res;	
//console.log('valisal '+item+' -> '+res);

}//end func


function handleChange(e, typ, rqd){
//console.log('handleChange nam: '+e.target.name);

let {name, value}=e.target;

value=value.replace('#','');
if (name=="MPE_SALARY_AMT")
	value=moneyCheck(value);
else if (typ=="date"){
	value=value.trim();
	if (value.length>10)
		value="";
	else{
		const yr=1*(value.substring(0,4));
		if (yr>=1000){
			//this condition says the user has entered the full year
			const curryear=new Date().getFullYear();
			if (Math.abs(yr-curryear)>80)
				value="";
			//const mm=value.substring(5,7);
			//const dd=value.substring(8,10);	
			//var d = new Date(2011,10,30);
			}//end if
		}//end else
	}//end if
	

e.target.value=value;
console.log('handleChange value: '+value);

//const value=(rawvalue==null)?'':rawvalue.trim();
/*
to do: implement validations:
(i) names are alpha only
(ii) money is numbers only
(iii) remove all not alpha-numeric other than -_', also check lengths of names and emails
*/


showbtnsave();

	if (rqd==1 && document.getElementById('RQD_'+name)){
		console.log('RQD_'+name+' value: '+value);
		document.getElementById('RQD_'+name).style.color=(value=='')?'red':'blue';
		}
		

	setWptapp((prev) => {
	return {...prev, doSectionChange:false, [name]:value}
	});


}//end func







async function uploadfiles(){
	console.log('uploadfiles: '+selectedFiles.length);
	
//setAxiofl({ selectedFile: event.target.files });	
	//event.target.files
/*
ensure the below line in node js has the correct array size of 3 
router.post('/uploadfiles', upload.array('filesupload',3), (req, res, next) => {
*/	
 
 const FormData = require('form-data'); // npm install --save form-data

const form = new FormData();

form.append('WPT_APP_ID', wptapp.WPT_APP_ID);
form.append('REF_NUM', wptapp.REF_NUM);
form.append('USERNAME', sessionStorage.getItem("USERNAME"));
//let formfiles={foto:false,sign:false,scans:false};
let filenames={scans:''};
let scansFile=null;
let numfilesupload=0;
for (var i=0; i<selectedFiles.length; i++){
	const currfile=selectedFiles[i].file;
	const name=selectedFiles[i].name;
	//console.log('name: '+name);

	if (name=='scans.pdf'){
		scansFile=new File([currfile], 'scans.pdf');
		filenames.scans=currfile.name;
		numfilesupload++;
		//formfiles.scans=true;
		}//end if
	
	}//end for
//requires a multipart form with a filename header
form.append('filename', filenames.scans);
form.append('MPE_SCANS', filenames.scans);

if (scansFile!=null)	{form.append('filesupload', scansFile);}

/*
const request_config = {
    onUploadProgress: data => {
      //Set the progress value to show the progress bard
      setProgress({perct:Math.round((100 * data.loaded) / data.total)});
    },
};
  headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      "Access-Control-Allow-Origin": "*",
	  "Accept-Encoding": "gzip, deflate, br"
  }
filesupload
*/


const request_config = {
    onUploadProgress: data => {
      //Set the progress value to show the progress bard
      setProgress({perct:Math.round((100 * data.loaded) / data.total)});
    },
};
setDowait({show:true});

await axios.post(scansurl+'rarscans/uploadfile', form, request_config)
.then(res => afteruploadfiles(res.data, filenames.foto, filenames.scans))
.catch(error => { 
		setDowait({show:false});
         showsnackbar(error+"<br/>please try logout and login again");
     });//end catch
{/*
	function cb(res){
		console.log('cb: '+JSON.stringify(cb));
	}

*/}

	
}//end func


function afteruploadfiles(data, fotofilename, scansfilename){
	console.log('afteruploadfiles: '+JSON.stringify(data));
	if (document.getElementById('btnsubmitapp'))
		document.getElementById('btnsubmitapp').style.visibility='visible';
	
	cssclass("progresspiechart", "hidden", 1);
	
	//showsnackbar('record update complete');
	setDowait({show:false});

	if (scansfilename!='' && data.pdfPageCount<3)
		alert("The scanned documents in pdf format did not meet the requirement; it should be 3 pages or more");
	
}//end func



function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func

async function updatewptapp(e){
	

document.getElementById('btnsavechanges').style.visibility='hidden';


console.log('updatewptapp SUBMITTED_TO_CSC: '+wptapp.SUBMITTED_TO_CSC);
if (wptapp.SUBMITTED_TO_CSC!=null && wptapp.SUBMITTED_TO_CSC!=''){
	alert('changes cannot be saved because this application was submitted already!');
	return;
	}//end if
const sectionLetter=sectionnames[currsection.index].letter;

if (sectionLetter=='J'){
	uploadfiles();
	return;
	}//end if

let temp=[];
for (var i=0; i<currsectionfields.length; i++){
	const x=currsectionfields[i];
	const currField=arrFields[x];
	temp.push({
		FLD:currField.FLD
		,TYP:currField.TYP
		,RQD:currField.RQD
		,DATA:wptapp[currField.FLD]
	});
	}//end for

let params={
	WPT_APP_ID:wptapp.WPT_APP_ID
	, USERNAME:sessionStorage.getItem("USERNAME")
	, SCTN:sectionLetter
	, arrFields:temp
};

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params  )
  };

	setDowait({show:true});
	
  await fetch(resturl+'rarwpform/updatewptapp',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatewptapp(res) )
      .catch(err => updatewptapperror(err) );
}//end func


function afterupdatewptapp(res){
	
//navSubmitwptform.current?.click();
navigate("/submitwpform", {state:{wptapp:wptapp}});
//setDowait({show: false});
}//end func	

function updatewptapperror(err){
	setDowait({show:false});
	console.log(err);
	showsnackbar("failed with error: "+err+"<br>maybe the server rejected something you typed");
	if (document.getElementById('btnsavechanges'))
		document.getElementById('btnsavechanges').style.visibility='visible';
	
}//end func	

	
async function saveWptappMpr(e){	

e.preventDefault();

let params={
	WPT_APP_ID:wptapp.WPT_APP_ID
	, USERNAME:sessionStorage.getItem("USERNAME")
	, EMPL_ID: document.getElementsByName("EMPL_ID")[0].value
};

    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params  )
  };

document.getElementById("btnsavempr").style.visibility="hidden";
	setDowait({show:true});
	
 await fetch(resturl+'rarwpform/savewptappemployer',requestOptions)
      .then(res => res.json())
      .then(res => 	afterSaveWptappMpr(res) )
      .catch(err => console.log(err));
}//end func

function afterSaveWptappMpr	(res){
setDowait({show:false});
console.log("afterSaveWptappMpr")	;

}//end func	
	
	
function senddefermsg(){
const modalsm=document.querySelector(".modalsm");	
if (deferparams.flag=="d" && !modalsm.classList.contains("show-modalsm"))	
	setDeferparams((prev)=>{return {...prev, flag:""}});
else	
	setDeferparams((prev)=>{return {...prev, flag:"d"}});
}//end func	
	
function toggleModalsm() {
/*
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");
console.log('modalsm is null: '+(document.querySelector(".modalsm")==null));
*/	

if (document.querySelector(".modalsm")){
	const modalsm=document.querySelector(".modalsm");
	modalsm.classList.toggle("show-modalsm");
	/*
	a problem occurs sometimes when the popup window does not close when the x button is clicked
	below we log to check if modalsm still contains the show-modalsm class
	modalsm.classList.contains('show-modalsm'): false
	modalsm.classList.contains('show-modalsm'): true
	the event fires twice in the logs.  conclusion is theres overlap of button and window events when button is clicked
	Found that there was a second line of code calling closeButton.addEventListener("click", toggleModalsm);
	Problem solved after removing that second call to closeButton.addEventListener("click", toggleModalsm);
	console.log("modalsm.classList.contains('show-modalsm'): "+modalsm.classList.contains("show-modalsm"));
	*/
	
	
	
	if (modalsm.classList.contains("show-modalsm")){
		//when the popup opens, focus emailmsg and addEventListeners 
		document.getElementsByName('EML_MSG')[0].focus();
		document.getElementsByName('EML_MSG')[0].value='';
		
		if (document.querySelector(".close-button")){
			const closeButton = document.querySelector(".close-button");
			if(!closeButton.classList.contains('attached-listener')){
				closeButton.classList.add('attached-listener');
				closeButton.addEventListener("click", toggleModalsm);
				window.addEventListener("click", windowOnClick);
				}//end if
			}//end if
	
		}//end if
	}//end if



}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");	
	
	
	
    if (event.target === modalsm) {
		//console.log("will call toggleModalsm() from inside windowOnClick(event)");
    	toggleModalsm();
    }
}//end func


function setemailmessage(){
const msg=document.getElementsByName('emailmsg')[0].value;
setEmail((prev)=>{
	return {...prev, MESSAGE:msg}

});
}//end func

async function openScans(e, filename) {
e.preventDefault();

const relFilepath=wptapp.REF_NUM+"/"+filename;

const params={
	filepath:relFilepath
	, TBL: "WPT"
	, WPT_APP_ID: wptapp.WPT_APP_ID
	, AD_USER:sessionStorage.getItem("AD_USER")??""
	, FILENAME: filename
	, FLAG_DL: 1
	};
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

	if (filename=="latescan.pdf")
		setLatedlwait({show:true});
	else
		setDlwait({show:true});
	
//	await fetch('http://127.0.0.1:3001/rarwpform/getwptappfile',requestOptions)
 await fetch(scansurl+'rarwpform/getwptappfile',requestOptions)
      .then(res => afteropenScans(res, filename))
      .catch(err => console.log(err));


}//end func

async function afteropenScans(res, filename){
const downloadFilename = wptapp.REF_NUM+"_"+filename;
const blob = await res.blob();
//console.log('blob.length: '+blob.length);
const data = window.URL.createObjectURL(new Blob([blob]));

const link = document.createElement("a");
link.href = data;
link.setAttribute("download", downloadFilename);
document.body.appendChild(link);
link.click();
//link.parentNode!.removeChild(link);	
link.parentNode?.removeChild(link);	

if (filename=="latescan.pdf")
	setLatedlwait({show:false});
else
	setDlwait({show:false});

getdocsdlcount();
}//end func



async function rptwptfrmfld (e) {
e.preventDefault();


const params={
	 WPT_APP_ID: wptapp.WPT_APP_ID
	, REF_NUM: wptapp.REF_NUM
	, AD_USER:sessionStorage.getItem("AD_USER")??""
	};
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

e.target.style.visibility='hidden';

  fetch(resturl+'rarwpform/rptwptfrmfld',requestOptions)
      .then(res => afterrptwptfrmfld(res, e))
      .catch(err => console.log(err));


}//end func

async function afterrptwptfrmfld(res, e){

e.target.style.visibility='visible';

const downloadFilename = "Appform_"+wptapp.REF_NUM+".pdf";
const blob = await res.blob();
//console.log('blob.length: '+blob.length);
const data = window.URL.createObjectURL(new Blob([blob]));

const link = document.createElement("a");
link.href = data;
link.setAttribute("download", downloadFilename);
document.body.appendChild(link);
link.click();
//link.parentNode!.removeChild(link);	
link.parentNode?.removeChild(link);	


}//end func


async function getnextwptapp(e, SEQ_NO){

if (e)
	if (e.target)
		e.target.classList.add("hidden");
	

const params={
	WPT_APP_ID: wptapp.WPT_APP_ID
	, username:sessionStorage.getItem("USERNAME")
	, processarea: sessionStorage.getItem("PROCESS_AREA")
	, tcisland: sessionStorage.getItem("TC_ISLAND")
	, SEQ_NO: SEQ_NO
	};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

await  fetch(resturl+'rarwpform/getnextwptapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetnextwptapp(res) )
      .catch(err => console.log(err));

}//end func

function aftergetnextwptapp(res){
	console.log("aftergetnextwptapp: "+JSON.stringify(res));
	let WPT_APP_ID=0;
	
	if (res.length)
		if (res[0].WPT_APP_ID)
			WPT_APP_ID=res[0].WPT_APP_ID;
		
	if (WPT_APP_ID==0){
		showsnackbar("sorry, could not find the next application");
		return;
		}//end if
	else{
		//navigate("/wptform", {state:{WPT_APP_ID:WPT_APP_ID}});
		setWptapp((prev)=>{
			return {...prev, WPT_APP_ID:WPT_APP_ID, REF_NUM:undefined}
		});
	
		}//end else
	
}//end func

async function getemployers(e){

const strCompany = (""+e.target.value).trim();

/*
setMpr((prev)=>{
return {...prev, COMPANY:strCompany}
})
*/
	//console.log('getemployers strCompany.length: '+strCompany.length);
	if (strCompany.length<3){
		($( "#MPR_NAME" )).autocomplete({source: []});
		//document.getElementById('cbmprdone').disabled=true;
		return;
		}	


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {MPE_OR_MPR:"companyname", crit:strCompany, GOVT:0} )
  };		

await  fetch(resturl+'rarwpform/getemployers',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetemployers(res) )
      .catch(err => console.log(err));

}//end func


function aftergetemployers(res){
//document.getElementById('cbmprdone').disabled=false;
let arrCmp=[];
let arrEMPL_ID=[];
	
res.map((col, index) => {
			arrCmp.push(col['COMPANY']);
			const key="emplid_"+index+"_";
			arrEMPL_ID.push(<>
					<input name='HDN_EMPL_ID[]' key={key+"a"} value={col['EMPL_ID']} type='hidden' />
					<input name='HDN_COMPANY[]' key={key+"b"} value={col['COMPANY']} type='hidden' />
					</>
					);
			});
	
	console.log('arrCmp.length: '+arrCmp.length);
	setEmplids(arrEMPL_ID);
    ($( "#MPR_NAME" )).autocomplete({source: arrCmp});   
  

  $('#MPR_NAME').autocomplete('search', '');
  document.getElementsByName('MPR_NAME')[0].focus();	
}//end func	

function updatesectionK(e){
	const {name, value}=e.target;
	console.log("updatesectionK: "+name+" "+value);
		setWptapp((prev)=>{
		return {
			...prev
			, doSectionChange:false
			, [name]:value
			};
			});
/*
this simply was not working
also the aftertriggerselect fn in jquery autocomplete cannot call this anyway with the EMPL_ID
so the params for checkemplid will use just values from document.getElementsByName
	
	const [elem, value]=[e.target.name, e.target.value];
	const datas={[elem]:value};
	console.log('datas:'+JSON.stringify(datas));
	//console.log('updatesectionK value:'+value);
	//doSectionChange:false so as to not read from db
	setWptapp((prev)=>{
		return {
			...prev
			, doSectionChange:false
			, [elem]:value
			};
	});
*/

}//end func	








async function submitform2(e){
	
	e.preventDefault();

	const flag=deferparams.flag;
	
	let ARR_APP_ID=[];
	let ARR_MPE_OCCUPATION=[], ARR_MPE_NAME=[], ARR_IMG_REF=[], ARR_SUBMITTED=[];
	
	
	ARR_APP_ID.push(wptapp.WPT_APP_ID);
	ARR_IMG_REF.push(wptapp.IMG_REF);
	ARR_MPE_NAME.push(wptapp.MPE_NAME);
	ARR_MPE_OCCUPATION.push(wptapp.MPE_OCCUPATION);
	ARR_SUBMITTED.push(wptapp.CHR_SUBMITTED_TO_CSC);

		const confirmmsg=ARR_APP_ID.length+" application(s) will be "+deferparams.msgtxt+".  are you sure?";
	const result=await window.confirm(confirmmsg);
	
	if (!result)
		return;

	const form2=document.getElementById("form2");
	// This is the important part, test if form is valid
	if (form2.checkValidity() === false){
		// This is the magic function that displays the validation errors to the user
		form2.reportValidity();   
		return; 
		}//end if
	
	//EML_MSG
	const params={
		USERNAME:sessionStorage.getItem("USERNAME")
		, ARR_APP_ID:ARR_APP_ID
		, ARR_SUBMITTED:ARR_SUBMITTED
		, ARR_IMG_REF:ARR_IMG_REF
		, ARR_MPE_NAME:ARR_MPE_NAME
		, ARR_MPE_OCCUPATION:ARR_MPE_OCCUPATION
		, CREATE_USER: wptapp.CREATE_USER
		, DEFER_REASON: deferparams.DEFER_REASON
		, EML_MSG: deferparams.EML_MSG
		, STATUS: (flag=='d')?"NOTSUBMIT":"CANCELLED"
		};	
	
	deferorcancel(e, params, deferparams.msgtxt);
	
}//end func	


async function approveconssn(){
		
const conf=window.confirm("The application will proceed as if paid.  Approve this?");		
if (!conf)
	return;

	const params={
		WPT_APP_ID: wptapp.WPT_APP_ID
		, USERNAME: sessionStorage.getItem("USERNAME")??""
	};
	
	console.log(JSON.stringify(params));
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setDowait({show:true});

  await fetch(resturl+'rarwpform/approveconssn',requestOptions)
      .then(res => res.json())
      .then(res => 	afterapproveconssn(res) )	
	
}//end func

	
function afterapproveconssn(res, phrase){
	
	setDowait({show:false});
	
	const STATUS=res.length?(res[0].STATUS??""):"";
	if (STATUS=="")
		showsnackbar("that did not work");
	else {
		showsnackbar("done!");
		setWptapp((prev)=>{
			return {...prev, STATUS:STATUS}
			});
		}//end else
	
	
	
	
}//end func


async function makeapplyletter(e){
	
	e.preventDefault();
	
	const params={
		USERNAME:sessionStorage.getItem("USERNAME")
		, WPT_APP_ID: wptapp.WPT_APP_ID
		, filename: wptapp.MPE_FIRST_NAME
		};
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setDowait({show:true});
cssclass(e.target.id, "hidden", 1);

  await fetch(resturl+'rarwpform/makeapplyletter',requestOptions)
      .then(res => 	aftermakeapplyletter(e, res) )	
	
}//end func

	
async function aftermakeapplyletter(e, res){
	setDowait({show:false});
	cssclass(e.target.id, "hidden", 0);
	
		const blob = await res.blob();
	saveAs(blob, wptapp.MPE_FIRST_NAME+".docx");

	
}//end func


	
async function deferorcancel(e, params, phrase){
		
	//crit.DEFER_REASON
	
	console.log(JSON.stringify(params));
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setDowait({show:true});

  await fetch(resturl+'rarwpform/deferorcancelwptapps',requestOptions)
      .then(res => res.json())
      .then(res => 	afterdeferorcancel(res, phrase) )	
	
}//end func

	
function afterdeferorcancel(res, phrase){
	
	setDowait({show:false});
	
	setDeferparams((prev)=>{
		return {...prev, flag:""}
	});
	
	
	let UPDATE_COUNT=0;
	
	if (res.length)
		if (res.length==1)
			UPDATE_COUNT=res[0].UPDATE_COUNT;
	
	if (UPDATE_COUNT>0){
		toggleModalsm();
		showsnackbar("updated complete: "+UPDATE_COUNT+" application(s) "+phrase);
		
		if (res[0].NEXT_WPT_APP_ID!=null)		
			setWptapp({WPT_APP_ID:res[0].NEXT_WPT_APP_ID});
		
/*
		setCrit((prev)=>{
			return {...prev, shownextbutton:location.state.shownextbutton}
		});	
*/	
		
		}//end if
	else window.alert("That seemed not to have worked");
	
}//end func




function aftersenddeferemailOld(res){
	
	setDowait({show:false});

console.log("aftersenddeferemail: "+JSON.stringify(res) );

let NEXT_WPT_APP_ID=0;
	
	if (res.length)
		if (res.length==1)
			NEXT_WPT_APP_ID=res[0].NEXT_WPT_APP_ID;
		
	if (NEXT_WPT_APP_ID==0)
		showsnackbar('something went wrong.  please try again');
	else{
		toggleModalsm();
		//alert('email was sent.  all done!');
		showsnackbar("will try open the next application in line");
		if (NEXT_WPT_APP_ID!=null){
			//navigate("/wptform", {state:{WPT_APP_ID:NEXT_WPT_APP_ID}});
			//navigate did not work.  try to call the useEffect
			setWptapp({WPT_APP_ID:NEXT_WPT_APP_ID});
/*
			setWptapp((prev)=>{
				return {...prev, WPT_APP_ID:NEXT_WPT_APP_ID, REF_NUM}
			});
*/

			}//end if
			
		}//end else
		
}

function updateEmplid(emplId){
	//this from the autocomplete & aftertriggerselect
	setWptapp((prev)=>{
		return {
			...prev
			, EMPL_ID:emplId
			};
	});	
}//end func

function selectedFilesChange(event, index, filename){
//console.log('selectedFilesChange event.target.files.length: '+event.target.files.length);
//console.log('selectedFilesChange index: '+index);

const i=selectedFiles.length;
console.log('selectedFiles.length: '+i);
let temp=selectedFiles;
temp[i]={file:event.target.files[0], name:filename};
//temp[index]=event.target.files[0]
setSelectedFiles(temp);
if (document.getElementById('btnsavechanges'))
	document.getElementById('btnsavechanges').style.visibility='visible';

if (document.getElementById('btnsubmitapp'))
	document.getElementById('btnsubmitapp').style.visibility='hidden';


const sectionLetter=sectionnames[currsection.index].letter;

if (sectionLetter=='J'){
	setProgress({perct:0});
	cssclass("progresspiechart", "hidden", 0);
	}//end if

}//end func


function writeClipboard(e, text1){
if (e)
	e.preventDefault();
/* var  text1= "Example text to appear on clipboard"; */
navigator.clipboard.writeText(text1).then(function() {
  //console.log('Async: Copying to clipboard was successful!');
  showsnackbar(text1+" was copied to clipboard");
}, function(err) {
  console.error('Async: Could not copy text: ', err);
});	
	
}//end func

const attr="val";
//const coverlink="http://localhost:3000/upload/"+wptapp.REF_NUM+"/coverpage.pdf";
const refurl=sessionStorage.getItem("UPLOADURL")+wptapp.REF_NUM+"/";


//AD_USER = (AD_USER==undefined||AD_USER==null)?"":AD_USER;
const IRD_LOGIN_ID=sessionStorage.getItem("IRD_LOGIN_ID");
//IRD_LOGIN_ID = (IRD_LOGIN_ID==undefined||IRD_LOGIN_ID==null)?"":IRD_LOGIN_ID;


let inputImgRef=<input name='IMG_REF' defaultValue={wptapp.IMG_REF} onChange={(e)=>{updatesectionK(e);}} size='8' required  autoComplete="off" />;
if (wptapp.APP_TYPE=='First Time')
	inputImgRef=<input name='IMG_REF' defaultValue={wptapp.IMG_REF}  size='8' readOnly className="gnsbro" required  autoComplete="off" />

let alertlastseen=<></>;
if (wptapp.ALERT_LAST_SEEN!="")
	alertlastseen=<>
				<tr>
				<td align='center' colSpan='2' style={{color:"brown"}}
				title="maybe you can check with that person if you still need to process this application" 
				>
				<img src="img/notification-bell.png" border="0" />&nbsp;{wptapp.ALERT_LAST_SEEN}
				</td>
				</tr>
				</>;

let TR_WEB_USER_VERIFIED=<></>;
if (wptapp.WEB_USER_VERIFIED!=1)
	TR_WEB_USER_VERIFIED=<>
				<tr>
					<td align='right' >User Verified:</td>
					<td align='left' >
						<input name="WEB_USER_VERIFIED" type="text" value="" onChange={(e)=>{e.preventDefault();}}  required className="gnsbro" className="read-only"  />
						&nbsp;
						<a href="#" title="verify or refuse user registration" onClick={(e)=>{e.preventDefault(); navigate("/newwebuser", {state:{returnpg:{name:"Application Form",path:"wptform"}, WPT_APP_ID:wptapp.WPT_APP_ID, WEB_USER_ID:wptapp.WEB_USER_ID}}); }}  ><img src="img/openpage.webp" height="18" border="0" /></a> 
						
					</td>
				</tr>
				</>;




function deferparamsChange(e){
const {name, value} = e.target;

console.log("deferparamsChange: "+name+" "+value);
	

if (name=="DEFER_REASON"){
	let emlMsg="";
	for (var i=0; i<deferreasons.length; i++)
		if (deferreasons[i]==value)
			emlMsg=emlmsgs[i];
			
	setDeferparams((prev)=>{
		return {...prev, [name]:value, EML_MSG:emlMsg}
	});
	}//end if
else
	setDeferparams((prev)=>{
		return {...prev, [name]:value}
	});
	
}//end func

function nextcaseworkerapp(e){

e.preventDefault();
const elem=document.getElementsByName("lscaseworkerapps")[0];
const index=elem.selectedIndex;
if (index+1<elem.options.length){
	setWptapp((prev)=>{
		return {...prev, WPT_APP_ID: elem.options[index+1].value, REF_NUM:undefined}
	});
	}
else
	alert("there are no more records");
	
}//end func



function updateProgressElement(percentage) {
	document.getElementById("percentage").innerHTML=Math.round(percentage,0)+"%";
  document.getElementById('progresspiechart').style.background="conic-gradient(" + FILUP_PIE_COLOR_PASSED + " 0, "  + FILUP_PIE_COLOR_PASSED + " " + percentage + "%, "  + FILUP_PIE_COLOR_LEFT + " 0)";
}//end func

//console.log("IRD_LOGIN_ID: "+IRD_LOGIN_ID);
let SEQ_NO=0;
if (location.state)
	if (location.state.shownextbutton && location.state.SEQ_NO){
		SEQ_NO=location.state.SEQ_NO;
		if (crit.shownextbutton!=location.state.shownextbutton)
		setCrit((prev)=>{
			return {...prev, shownextbutton:location.state.shownextbutton}
		});
		}//end if
		
	


  return (
    <>
	
<div key="divctnr" className="container" style={{"backgroundColor":"#F0F0F0", "marginBottom":"36px"}} >
  <div key="divsn1"  className="section snwidth1" >
  
    
  <fieldset className="fieldsetformside" >
 <legend style={{marginBottom:"9px"}} >Click Section Names</legend>
 
  <table className='tblsectionnames'  align='center' >
  <tbody>
	  {tblsections}
  </tbody>
  </table>
  <p align='center'>Immigration Ref #<br/>{wptapp.IMG_REF}</p>
  </fieldset>
  {/*section 1*/}
  </div>

  <div key="divsn2" className="section snwidth2"  >
{/*sections :*/}
<table align='left' className="tblsectiontitle"  cellPadding='0' cellSpacing='0' >
<tbody>
<tr>
	<td align='left' >
	{/*
		excel file: <input type="file" onChange={onFileChange}  style={{"width":"80px", "height":"30px"}} />
		&nbsp;&nbsp;
		<button onClick={onFileUpload} >upload file</button>	
	*/}	

	</td>
</tr>
	{currsection.index!=null && sectionnames.length>0 &&
		<tr>
			<td align='left' >Section {sectionnames[currsection.index].letter}: {sectionnames[currsection.index].name}</td>
		</tr>
	}
</tbody>
</table>

<p style={{height:"6px"}}>&nbsp;</p>
{/*
<select name='SCTN' value={section.letter} onChange={(e)=>{handleSectionChange(e.target.value);}} key='SCTN' >
<option value='' > * * * sections * * *  </option>
{sectionnames}
</select>
<br/>
{formControls}
*/}

	
		{AD_USER!="" && wptapp.SUBMITTED_TO_CSC!='' && 
		<form method='POST' id='form1' style={{display:"none"}} onSubmit={(e)=>{updateReviewtype(e);}}  >
		<table align='center'  style={{marginBottom:"24px"}} >
		<tbody>
		<tr>
			<td align='center' colSpan='2' style={{paddingBottom:"9px"}} >
			{dlwait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
			{!dlwait.show && <a href="#" onClick={(e)=>{openScans(e, "scans.pdf");}} className="nodecor" ><img src='img/pdf.gif' border='0' /> click here to see scanned documents</a> }
			</td>
		</tr>
		{
		wptapp.LATE_SCAN_SIZE>0 && 	
		<tr>
			<td align='center' colSpan='2' style={{paddingBottom:"9px"}} >
			{latedlwait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
			{!latedlwait.show && <a href="#" onClick={(e)=>{openScans(e,"latescan.pdf");}} className="nodecor" ><img src='img/pdf.gif' border='0' /> click here to see late scanned documents</a>}
			</td>
		</tr>
		}
		
			{
			wptapp.LC_APPEAL_PDF_SIZE>0 && 	
			<tr>
				<td align='center' colSpan='2' style={{paddingBottom:"9px"}} >
				{latedlwait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
				{!latedlwait.show && <a href="#" onClick={(e)=>{openScans(e,"labourscan.pdf");}} className="nodecor" ><img src='img/pdf.gif' border='0' /> click here to see appeal scanned document</a>}
				</td>
			</tr>
			}

			{
			wptapp.BAL_RCP_PDF_SIZE>0 && 	
			<tr>
				<td align='center' colSpan='2' style={{paddingBottom:"9px"}} >
				{latedlwait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
				{!latedlwait.show && <a href="#" onClick={(e)=>{openScans(e,"balrcpscan.pdf");}} className="nodecor" ><img src='img/pdf.gif' border='0' /> click here to see paid balance receipts</a>}
				</td>
			</tr>
			}		
		
		
		<tr>
			<td align='right' >Date Documents Viewed:</td>
			<td align='left' ><input required defaultValue={scans.dtviewed} onChange={(e)=>{e.preventDefault();}} className="read-only" /></td>
		</tr>
		<tr>
			<td align='right' >
			{wptapp.MPR_COUNT>0 && <img src='img/greentick.png' border='0' height='16' />}
			{wptapp.MPR_COUNT==0 && <img src='img/alert.png' border='0' height='16' />}
			<a href="#" onClick={(e)=>{saveWptappMpr(e);}} id="btnsavempr" style={{visibility:"hidden"}} ><img src="img/floppysm.png" border="0" height="16" /></a>
			&nbsp;&nbsp;<input name='EMPL_ID' defaultValue={wptapp.EMPL_ID} onFocus={(e)=>{emplIdFocus(e); }} title="Employer's Id" readOnly className="gnsbro" size='4' style={{textAlign:"center"}} />
			&nbsp;&nbsp;Employer:
			</td>
			<td align='left' ><input defaultValue={wptapp.MPR_NAME} name='MPR_NAME' id='MPR_NAME' size='28' onChange={(e)=>{getemployers(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} placeholder="enter employer's name" required />
			</td>
		</tr>

		{
		wptapp.MPR_SWITCH_MSG!="" && 
		<tr>
			<td align='center' colSpan="2" className="boldbrown" ><img src="img/redalert.png" height="20" border="0" /> {wptapp.MPR_SWITCH_MSG}</td>
		</tr>
		
		}
		<tr>
			<td align='right' >Application Type:</td>
			<td align='left' ><select name="APP_TYPE_ID" value={wptapp.APP_TYPE_ID}  onChange={(e)=>{updatesectionK(e);}} >{combolaborcltype}</select></td>
		</tr>		
		<tr>
			<td align='right' >
			{wptapp.MPE_COUNT>0 && <img src='img/greentick.png' border='0' height='16' />}
			{wptapp.MPE_COUNT==0 && <img src='img/alert.png' border='0' height='16' />}
			&nbsp;Immig. Ref #:</td>
			<td align='left' >
				{inputImgRef}
				&nbsp;&nbsp;
				<input name='PERSON_ID' defaultValue={wptapp.PERSON_ID} readOnly className="gnsbro" size='5' title='person Id'  autoComplete="off" />
			</td>
		</tr>
		<tr>
			<td align='right' >Applicant's Name:</td>
			<td align='left' ><input value={wptapp.MPE_FIRST_NAME+' '+wptapp.MPE_LAST_NAME} className="gnsbro" readOnly /></td>
		</tr>
		<tr>
			<td align='right' >Job Title:</td>
			<td align='left' ><input value={wptapp.MPE_OCCUPATION}  size='28'  className="gnsbro" readOnly /></td>
		</tr>
		<tr>
			<td align='right' >Salary:</td>
			<td align='left' ><input value={wptapp.MPE_SALARY}  size='15'  className="gnsbro" readOnly /></td>
		</tr>
		<tr>
			<td align='right' >Endorsements:</td>
			<td align='left' ><input value={wptapp.ENDORSE_SPOUSE+" "+wptapp.ENDORSE_CHILD}  size='15'  className="gnsbro" readOnly /></td>
		</tr>

		<tr>
			<td align='right' >Review Type:</td>
			<td align='left' >
				<select name='REVIEW_TYPE' required value={wptapp.REVIEW_TYPE} onChange={(e)=>{updatesectionK(e);}} >
				<option value='' ></option>
				{comboreviewtype}
				</select>
				{/*<input value={} onChange={(e)=>{e.preventDefault();}} className="gnsbro" readOnly />*/}
			</td>
		</tr>
		
		{TR_WEB_USER_VERIFIED}
		{alertlastseen}
		 
		 
		 
		<tr>
			<td align='right' style={{paddingRight:"12px"}} ><a className='nodecor' href='#' onClick={(e)=>{e.preventDefault(); senddefermsg(); }} ><img src="img/refuseapp.png" border="0" height="28" /> type a defer message</a></td>
			<td align='left' >
			
			
			
			{IRD_LOGIN_ID!="" && wptapp.CONCESSION==0 && <button className='button'  >add new payment vouchers</button>}
			{IRD_LOGIN_ID!="" && wptapp.CONCESSION==1 && wptapp.STATUS=='NEW' && <button className="button" >approve concession application</button>}
			</td>
		</tr>

		<tr>
			<td align='right'  >Agency:</td>
			<td align='left' ><input defaultValue={wptapp.AGENCY} className="gnsbro" readOnly /></td>
		</tr>
		</tbody>
		</table>
		</form>
		}
		{/*onClick={(e)=>{navigate("/wpvouchers",{state:{WPT_APP_ID:wptapp.WPT_APP_ID}});}}*/}
		{emplids}
	{formControls}
	<br/>
	<table className="tblbuttons"  >
	<tbody>
	<tr>
	<td align='center' >
	&nbsp;
	{/*<a href='#' className="nodecor" onClick={(e)=>{e.preventDefault();window.scrollTo(0, 0);}} ><img src='img/uparrow.png' title='scroll to page top' border='0' /> page top</a>*/}
	</td>

	<td align='left' >
	{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
	{
	!dowait.show && 
	<input type='button' className='button' value='save changes' id='btnsavechanges' onClick={(e)=>{updatewptapp(e)}}  />
	}	
	</td>

	{/*navSubmitwptform.current?.click();	*/}
	{wptapp.SUBMITTED_TO_CSC=='' && <td align='left' >
	<input type='button' className='button' value='ready to submit application' id='btnsubmitapp' onClick={(e)=>{navigate("/submitwpform", {state:{wptapp:wptapp}});}}   />
	</td>
	}
	
	{/*
	{wptapp.SUBMITTED_TO_CSC!=null && username!=null && <td align='left' >
	<input type='button' className='button' value='ready to export application' id='btnexportapp' onClick={(e)=>{navExportform.current?.click();}}   />
	</td>
	}
	
	*/}	
	
	</tr>
	</tbody>
	</table>

<div align="center" style={{marginTop:"18px"}} >
	<div id="progresspiechart" className="hidden" ><p id="percentage" >0%</p></div>
</div>


  </div>

  <div key="divsn3" className="section snwidth3" >
  
  <fieldset className="fieldsetformside" >
 <legend style={{marginBottom:"9px"}} >Application {wptapp.WPT_APP_ID} Info ({wptapp.STATUS})</legend>
	<table  align='center'  >
 <tbody>
	<tr>
	<td align='left' colSpan="2"  >Ref #: </td>
	</tr>
	<tr>
	<td align='left' colSpan="2"  style={{paddingLeft:"18px"}} >
	{wptapp.REF_NUM}
	</td>
	</tr>
	<tr>
	<td align='left' colSpan="2" >Labor Clear ID: </td>
	</tr>
	<tr>
	<td align='left' colSpan="2"  style={{paddingLeft:"18px"}} >
	<a href="#" onClick={(e)=>{writeClipboard(e, wptapp.TC_LBR_CLR_APP_ID);}} className="nodecor" title="click to copy ID" ><img src="img/copy.png" height="18" border="0" /> {wptapp.TC_LBR_CLR_APP_ID}</a>
	</td>
	</tr>
	
	<tr>
	<td align='left' colSpan="2"  >Email: </td>
	</tr>
	<tr>
	<td align='left' colSpan="2"  style={{paddingLeft:"18px"}} >
	<a href="#" target="_blank" title="view user registration" onClick={(e)=>{e.preventDefault(); navigate("/newwebuser", {state:{WPT_APP_ID:wptapp.WPT_APP_ID, WEB_USER_ID:wptapp.WEB_USER_ID}}); }}  >{wptapp.EMAIL_TO}</a>
	</td>
	</tr>


	<tr>
	<td align='left' colSpan="2" >Last Update: </td>
	</tr>
	<tr>
	<td align='left' colSpan="2"  style={{paddingLeft:"18px"}} >
	{wptapp.CHR_MODIFY_DATE}
	</td>
	</tr>
	
	{wptapp.SUBMITTED_TO_CSC!="" && 
		<>
		<tr>
		<td align='left' colSpan="2" >
		{/*<a href="#" onClick={(e)=>{return openCover(e);}} target="_none" style={{textDecoration:"none"}} >Submitted</a>*/}
		Submitted: 
		</td>
		</tr>
		<tr>
		<td align='left' colSpan="2"  style={{paddingLeft:"18px"}} >
		{wptapp.CHR_SUBMITTED_TO_CSC}
		</td>
		</tr>

		{/*
		<tr>
		<td align='left' colSpan="2"   >
		<a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); rptwptfrmfld(e);}} ><img src='img/appform.png' height="18" border='0' /> download application data</a>
		</td>
		</tr>
		
		*/}		



			
			{
			AD_USER!="" && 	
			<>
			<tr>
			<td align='left' colSpan="2"  >
			<a href="#" className="nodecor"  onClick={(e)=>{e.preventDefault(); setDeferparams((prev)=>{return {...prev, flag:"C"}}); }}  ><img src='img/trash.png' border='0' /> cancel this application</a>
			</td>
			</tr>
			{
			crit.shownextbutton==1 && 
			<tr>
			<td align='left' colSpan="2"  >
			<button onClick={(e)=>{getnextwptapp(e, SEQ_NO); }} className="button"  >get next application</button>
			</td>
			</tr>
			}
				{
	/*
				1*SUP_PVG==1 &&
					<tr>
					<td align='left' colSpan="2"  >
					Applications List: <a  href="#" onClick={(e)=>{nextcaseworkerapp(e); }} >get next application</a><br/>
					<select name="lscaseworkerapps" value={wptapp.WPT_APP_ID} onChange={(e)=>{setWptapp((prev)=>{return {...prev, WPT_APP_ID:e.target.value, REF_NUM:undefined}}); }} >
					{lscaseworkerapps}
					</select>
					</td>
					</tr>
	*/
				}
			</>
			}
		</>
		}
	
	{/*
wptapp.SUBMITTED_TO_CSC=="" && 
		<tr>
		<td align='center' colSpan="2" >
		<a href='#' id='btnwpuploadxl' className="nodecor" onClick={(e)=>{e.preventDefault(); navImportwpform.current?.click();}} ><img src='img/excel.png' height='24' border='0' /> upload excel file</a> 
		</td>
		</tr>	
	*/}
		

	<tr>
	<td align='left' colSpan="2" >Location: </td>
	</tr>
	<tr>
	<td align='left' colSpan="2"  style={{paddingLeft:"18px"}} >
	{wptapp.TC_ISLAND}
	</td>
	</tr>




			<tr>
			<td align='left' colSpan="2"  >
			{
			wptapp.REF_NUM && 
			<a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/scanneddocs", {state:{wptapp:wptapp}});  }} ><img src="img/filedrawer.png" height="22" border="0" /> manage files</a>
			}
			</td>
			</tr>


			<tr>
			<td align='left' colSpan="2"  >
			{
			wptapp.REF_NUM && 
			<a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/wptcardphoto", {state:{wptapp:wptapp}});  }} ><img src="img/images.png" height="20" border="0" /> photos/endorse</a>
			}
			
			</td>
			</tr>

			<tr valign="top" >
			<td align='center' colSpan="2"  >
				{
				wptapp.REF_NUM && 
				<img src={resturl+"rarwpform/getwptappfoto?path="+wptapp.REF_NUM+"/thumb.png"} 
				 border='0' 
				style={{backgroundImage:"img/transparent.png"}}
				/>
				}
			</td>
			</tr>
			

			{
			AD_USER=="" && 	
			<tr>
			<td align='left' colSpan="2"  >
			<a href="#" className="nodecor"  onClick={(e)=>{e.preventDefault(); navigate("/removeapps", {state:{wptapp:wptapp}});}}  ><img src='img/trash.png' border='0' /> remove app from list</a>
			</td>
			</tr>
			}	


		  {
			(AD_USER=="ajones" || USERNAME.toLowerCase()=="jw@globlgateway.com") && 
			<tr>
			<td align='left' colSpan="2"  >
			<a href="#" className="nodecor" id="btn_makeapplyletter" onClick={(e)=>{makeapplyletter(e);}} ><img src="img/msword.png" border="0" /> make apply letter</a>
			</td>
			</tr>
			}



			{/*
			
			*/}

				
	{
	AD_USER!="" && <>
	<tr>
	<td align='left' colSpan="2" >Case Worker: </td>
	</tr>
	<tr>
	<td align='left' colSpan="2"  style={{paddingLeft:"18px"}} >
	{wptapp.LC_CASE_WORKER}
	</td>
	</tr>	
	</>
	}



	</tbody>
	
	
	
	
	</table>
  </fieldset>
  </div>
</div>	

{/*
        <NavLink ref={navSubmitwptform} to={"/submitwpform"} style={{display:"none"}}
          state={{wptapp:wptapp, WPT_APP_ID:wptapp.WPT_APP_ID}}  >submitwpform</NavLink>

*/}

        <NavLink ref={navImportwpform} to={"/importwpform"} style={{display:"none"}}
          state={{WPT_APP_ID:wptapp.WPT_APP_ID, REF_NUM:wptapp.REF_NUM}}  >importwpform</NavLink>



	<div className="modalsm">
		<div className="modalsm-content">
			<span className="close-button">&times;</span>
			<div align='center' id='modalsmtext' >


			<form id="form2" method="POST" onSubmit={(e)=>{submitform2(e);}} >
			<table align="center" border="0" >
			<tbody>

			<tr>
				<td align="center" >
				<select name="DEFER_REASON" value={deferparams.DEFER_REASON} onChange={(e)=>{deferparamsChange(e);}} >
				<option value='' key="user_0" >* * * defer/cancel reasons * * * </option>
				{deferoptions}
				</select>
				</td>
			</tr>

			<tr>
				<td align="left"  >
				Email Message to Customer:
				<br/><textarea name="EML_MSG" cols="70" rows="8" required onChange={(e)=>{deferparamsChange(e);}} value={deferparams.EML_MSG} placeholder="select a reason from the list or type a reason here" ></textarea>
				</td>
			</tr>

			<tr>
			<td align="center">

				{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
				{
				!dowait.show && <>
				<button className='button'   >{deferparams.btntxt} applications</button>
				</>
				}	

			</td>
			</tr>



			</tbody>
			</table>
			</form>
			
	
			</div>
		</div>
	</div>

	{
	1*currsection.index<9 &&
	<div className="divnavbutton" >
		<a href='#' className="nodecor tooltip" onClick={(e)=>{e.preventDefault();window.scrollTo(0, 0);}} ><img src='img/uparrow.png' title='scroll to page top' border='0' /><span className='tooltiptext'>page top</span></a>
		&nbsp;&nbsp;
		<a href='#' className="nodecor tooltip" onClick={(e)=>{e.preventDefault();window.scrollTo(0, document.body.scrollHeight);}} ><img src='img/downarrow.png' title='scroll to page bottom' border='0' /><span className='tooltiptext'>page bottom</span></a>
	</div>
	}

<div id="snackbar">&nbsp;</div>

    </>
  );
  


};


export default Renderform;